import {getEnv} from '../../common/env/env';
import {BannerDto} from '../../common/shared/api/nicolas/vo/BannerDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {SimpleImageBanner} from '../generated/types';

export function createSimpleImageBanner({
  uid,
  image,
  title,
  scheme,
  bgcolor,
}: BannerDto): SimpleImageBanner {
  return {
    uid,
    imageUrl: image.startsWith('http')
      ? image
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: image,
          resolution: 'th3',
        }),
    title,
    scheme,
    shouldOpenNewWindow: OPEN_ON_NEW_WINDOW_SCHEME_LIST.some(_scheme =>
      scheme.startsWith(_scheme)
    ),
    bgColor: bgcolor,
  };
}

const OPEN_ON_NEW_WINDOW_SCHEME_LIST = [
  'kakaopage://exec?goto_auto_charge',
  'kakaopage://exec?open_web_with_auth/relay/tvpoint',
  'kakaopage://open/webview/autocharge',
  'kakaopage://open/webview/tvpoint',
];
